// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,ts_nocheck
// @generated from protobuf file "agency/quota/v1/quota.proto" (package "agency.quota.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../../google/protobuf/timestamp";
/**
 * QuotaConfig configures per-workspace quota limits.
 *
 * @generated from protobuf message agency.quota.v1.QuotaConfig
 */
export interface QuotaConfig {
    /**
     * policy determines soft vs hard enforcement.
     *
     * @generated from protobuf field: agency.quota.v1.QuotaEnforcementPolicy policy = 1
     */
    policy: QuotaEnforcementPolicy;
    /**
     * tier_id links to TierConfig for tier-based quota resolution.
     *
     * @generated from protobuf field: string tier_id = 8
     */
    tierId: string;
    /**
     * token_limit is the total token budget for the window.
     *
     * @generated from protobuf field: int64 token_limit = 2
     */
    tokenLimit: bigint;
    /**
     * refill_rate is tokens added per second (token bucket algorithm).
     *
     * @generated from protobuf field: int64 refill_rate = 3
     */
    refillRate: bigint;
    /**
     * max_burst is the maximum burst capacity.
     *
     * @generated from protobuf field: int64 max_burst = 4
     */
    maxBurst: bigint;
    /**
     * params contains extensible configuration (tier overrides, custom rules).
     *
     * @generated from protobuf field: map<string, string> params = 5
     */
    params: {
        [key: string]: string;
    };
    /**
     * ingress_rps_limit is the ingress request rate limit (requests per second).
     *
     * @generated from protobuf field: int32 ingress_rps_limit = 6
     */
    ingressRpsLimit: number;
    /**
     * ingress_burst is the maximum concurrent in-flight requests.
     *
     * @generated from protobuf field: int32 ingress_burst = 7
     */
    ingressBurst: number;
}
/**
 * CheckRequest requests quota pre-check before execution.
 *
 * @generated from protobuf message agency.quota.v1.CheckRequest
 */
export interface CheckRequest {
    /**
     * tenant is the tenant identifier.
     *
     * @generated from protobuf field: string tenant = 1
     */
    tenant: string;
    /**
     * workspace is the workspace identifier.
     *
     * @generated from protobuf field: string workspace = 2
     */
    workspace: string;
    /**
     * estimated_cost is the anticipated token consumption.
     *
     * @generated from protobuf field: int64 estimated_cost = 3
     */
    estimatedCost: bigint;
    /**
     * request_id uniquely identifies this check for audit trail.
     *
     * @generated from protobuf field: string request_id = 4
     */
    requestId: string;
    /**
     * session_id is the session making the request (optional).
     *
     * @generated from protobuf field: string session_id = 5
     */
    sessionId: string;
}
/**
 * CheckResponse is the outcome of a quota check.
 *
 * @generated from protobuf message agency.quota.v1.CheckResponse
 */
export interface CheckResponse {
    /**
     * permitted indicates if the request is allowed.
     *
     * @generated from protobuf field: bool permitted = 1
     */
    permitted: boolean;
    /**
     * remaining is the remaining quota after this request (if permitted).
     *
     * @generated from protobuf field: int64 remaining = 2
     */
    remaining: bigint;
    /**
     * policy_applied indicates which policy was used.
     *
     * @generated from protobuf field: agency.quota.v1.QuotaEnforcementPolicy policy_applied = 3
     */
    policyApplied: QuotaEnforcementPolicy;
    /**
     * checked_at is when the check occurred.
     *
     * @generated from protobuf field: google.protobuf.Timestamp checked_at = 4
     */
    checkedAt?: Timestamp;
    /**
     * denial_reason explains why the request was denied (if not permitted).
     *
     * @generated from protobuf field: string denial_reason = 5
     */
    denialReason: string;
    /**
     * retry_after_seconds suggests when to retry (if denied).
     *
     * @generated from protobuf field: int64 retry_after_seconds = 6
     */
    retryAfterSeconds: bigint;
}
/**
 * SpendDelta records actual resource consumption for quota tracking.
 *
 * @generated from protobuf message agency.quota.v1.SpendDelta
 */
export interface SpendDelta {
    /**
     * tenant is the tenant identifier.
     *
     * @generated from protobuf field: string tenant = 1
     */
    tenant: string;
    /**
     * workspace is the workspace identifier.
     *
     * @generated from protobuf field: string workspace = 2
     */
    workspace: string;
    /**
     * session_id is the session that consumed resources.
     *
     * @generated from protobuf field: string session_id = 3
     */
    sessionId: string;
    /**
     * actual_cost is the actual token consumption.
     *
     * @generated from protobuf field: int64 actual_cost = 4
     */
    actualCost: bigint;
    /**
     * timestamp is when the consumption occurred.
     *
     * @generated from protobuf field: google.protobuf.Timestamp timestamp = 5
     */
    timestamp?: Timestamp;
    /**
     * operation_type describes what consumed quota (e.g., "llm_call", "tool_execution").
     *
     * @generated from protobuf field: string operation_type = 6
     */
    operationType: string;
    /**
     * request_id links this delta to the originating QuotaCheckRequest.
     *
     * @generated from protobuf field: string request_id = 7
     */
    requestId: string;
    /**
     * estimated_cost is the original estimate (for accuracy tracking).
     *
     * @generated from protobuf field: int64 estimated_cost = 8
     */
    estimatedCost: bigint;
}
/**
 * ToolCallFrequencyCheckRequest checks if a tool call is within frequency limits.
 *
 * @generated from protobuf message agency.quota.v1.ToolCallFrequencyCheckRequest
 */
export interface ToolCallFrequencyCheckRequest {
    /**
     * tenant is the tenant identifier.
     *
     * @generated from protobuf field: string tenant = 1
     */
    tenant: string;
    /**
     * workspace is the workspace identifier.
     *
     * @generated from protobuf field: string workspace = 2
     */
    workspace: string;
    /**
     * tool_name is the tool being called.
     *
     * @generated from protobuf field: string tool_name = 3
     */
    toolName: string;
    /**
     * session_id is the session making the call.
     *
     * @generated from protobuf field: string session_id = 4
     */
    sessionId: string;
}
/**
 * ToolCallFrequencyCheckResult is the outcome of a frequency check.
 *
 * @generated from protobuf message agency.quota.v1.ToolCallFrequencyCheckResult
 */
export interface ToolCallFrequencyCheckResult {
    /**
     * permitted indicates if the call is allowed.
     *
     * @generated from protobuf field: bool permitted = 1
     */
    permitted: boolean;
    /**
     * current_frequency is the current call rate.
     *
     * @generated from protobuf field: int32 current_frequency = 2
     */
    currentFrequency: number;
    /**
     * limit is the configured maximum.
     *
     * @generated from protobuf field: int32 limit = 3
     */
    limit: number;
    /**
     * retry_after_seconds suggests when to retry (if denied).
     *
     * @generated from protobuf field: int64 retry_after_seconds = 4
     */
    retryAfterSeconds: bigint;
    /**
     * checked_at is when the check occurred.
     *
     * @generated from protobuf field: google.protobuf.Timestamp checked_at = 5
     */
    checkedAt?: Timestamp;
}
/**
 * QuotaState represents the current quota state for a workspace.
 *
 * @generated from protobuf message agency.quota.v1.QuotaState
 */
export interface QuotaState {
    /**
     * tenant is the tenant identifier.
     *
     * @generated from protobuf field: string tenant = 1
     */
    tenant: string;
    /**
     * workspace is the workspace identifier.
     *
     * @generated from protobuf field: string workspace = 2
     */
    workspace: string;
    /**
     * remaining_tokens is the current available quota.
     *
     * @generated from protobuf field: int64 remaining_tokens = 3
     */
    remainingTokens: bigint;
    /**
     * last_refill_at is when quota was last refilled.
     *
     * @generated from protobuf field: google.protobuf.Timestamp last_refill_at = 4
     */
    lastRefillAt?: Timestamp;
    /**
     * updated_at is when this state was last updated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 5
     */
    updatedAt?: Timestamp;
    /**
     * revision is the state revision for optimistic concurrency control.
     *
     * @generated from protobuf field: uint64 revision = 6
     */
    revision: bigint;
}
/**
 * QuotaExhaustedEvent signals quota limit violations.
 *
 * @generated from protobuf message agency.quota.v1.QuotaExhaustedEvent
 */
export interface QuotaExhaustedEvent {
    /**
     * tenant is the tenant identifier.
     *
     * @generated from protobuf field: string tenant = 1
     */
    tenant: string;
    /**
     * workspace is the workspace identifier.
     *
     * @generated from protobuf field: string workspace = 2
     */
    workspace: string;
    /**
     * session_id is the session that hit the limit.
     *
     * @generated from protobuf field: string session_id = 3
     */
    sessionId: string;
    /**
     * requested_cost is the request that exceeded quota.
     *
     * @generated from protobuf field: int64 requested_cost = 4
     */
    requestedCost: bigint;
    /**
     * remaining_tokens is the remaining quota at rejection time.
     *
     * @generated from protobuf field: int64 remaining_tokens = 5
     */
    remainingTokens: bigint;
    /**
     * occurred_at is when exhaustion occurred.
     *
     * @generated from protobuf field: google.protobuf.Timestamp occurred_at = 6
     */
    occurredAt?: Timestamp;
    /**
     * policy_applied indicates which policy was in effect.
     *
     * @generated from protobuf field: agency.quota.v1.QuotaEnforcementPolicy policy_applied = 7
     */
    policyApplied: QuotaEnforcementPolicy;
}
/**
 * RateLimitExceededEvent signals ingress rate limit violations.
 *
 * @generated from protobuf message agency.quota.v1.RateLimitExceededEvent
 */
export interface RateLimitExceededEvent {
    /**
     * tenant is the tenant identifier.
     *
     * @generated from protobuf field: string tenant = 1
     */
    tenant: string;
    /**
     * workspace is the workspace identifier.
     *
     * @generated from protobuf field: string workspace = 2
     */
    workspace: string;
    /**
     * user_sub is the user subject (optional, for per-user rate limits).
     *
     * @generated from protobuf field: string user_sub = 3
     */
    userSub: string;
    /**
     * current_rate is the current request rate.
     *
     * @generated from protobuf field: int32 current_rate = 4
     */
    currentRate: number;
    /**
     * limit is the configured rate limit.
     *
     * @generated from protobuf field: int32 limit = 5
     */
    limit: number;
    /**
     * occurred_at is when the violation occurred.
     *
     * @generated from protobuf field: google.protobuf.Timestamp occurred_at = 6
     */
    occurredAt?: Timestamp;
    /**
     * layer identifies which rate limit layer was exceeded (e.g., "per_user", "per_workspace").
     *
     * @generated from protobuf field: string layer = 7
     */
    layer: string;
}
/**
 * RecordRequest publishes spend delta after operation completion.
 *
 * @generated from protobuf message agency.quota.v1.RecordRequest
 */
export interface RecordRequest {
    /**
     * tenant is the tenant identifier.
     *
     * @generated from protobuf field: string tenant = 1
     */
    tenant: string;
    /**
     * workspace is the workspace identifier.
     *
     * @generated from protobuf field: string workspace = 2
     */
    workspace: string;
    /**
     * session_id is the session that consumed resources.
     *
     * @generated from protobuf field: string session_id = 3
     */
    sessionId: string;
    /**
     * tokens_consumed is the actual token consumption.
     *
     * @generated from protobuf field: int64 tokens_consumed = 4
     */
    tokensConsumed: bigint;
    /**
     * operation_type describes the billable operation.
     *
     * @generated from protobuf field: string operation_type = 5
     */
    operationType: string;
    /**
     * timestamp is when the spend occurred.
     *
     * @generated from protobuf field: google.protobuf.Timestamp timestamp = 6
     */
    timestamp?: Timestamp;
}
/**
 * RecordResponse confirms spend delta recording.
 *
 * @generated from protobuf message agency.quota.v1.RecordResponse
 */
export interface RecordResponse {
    /**
     * recorded indicates if the delta was recorded.
     *
     * @generated from protobuf field: bool recorded = 1
     */
    recorded: boolean;
    /**
     * recorded_at is when the delta was recorded.
     *
     * @generated from protobuf field: google.protobuf.Timestamp recorded_at = 2
     */
    recordedAt?: Timestamp;
}
/**
 * ReconcileRequest requests quota state reconciliation.
 *
 * @generated from protobuf message agency.quota.v1.ReconcileRequest
 */
export interface ReconcileRequest {
    /**
     * tenant is the tenant identifier.
     *
     * @generated from protobuf field: string tenant = 1
     */
    tenant: string;
    /**
     * workspace is the workspace identifier.
     *
     * @generated from protobuf field: string workspace = 2
     */
    workspace: string;
    /**
     * deltas are the spend deltas to reconcile.
     *
     * @generated from protobuf field: repeated agency.quota.v1.SpendDelta deltas = 3
     */
    deltas: SpendDelta[];
}
/**
 * ReconcileResponse confirms reconciliation completion.
 *
 * @generated from protobuf message agency.quota.v1.ReconcileResponse
 */
export interface ReconcileResponse {
    /**
     * tenant is the tenant identifier.
     *
     * @generated from protobuf field: string tenant = 1
     */
    tenant: string;
    /**
     * workspace is the workspace identifier.
     *
     * @generated from protobuf field: string workspace = 2
     */
    workspace: string;
    /**
     * deltas_processed is the count of processed deltas.
     *
     * @generated from protobuf field: int32 deltas_processed = 3
     */
    deltasProcessed: number;
    /**
     * remaining_tokens is the updated token balance.
     *
     * @generated from protobuf field: int64 remaining_tokens = 4
     */
    remainingTokens: bigint;
    /**
     * reconciled_at is when reconciliation completed.
     *
     * @generated from protobuf field: google.protobuf.Timestamp reconciled_at = 5
     */
    reconciledAt?: Timestamp;
}
/**
 * GetQuotaStateRequest requests current quota state.
 *
 * @generated from protobuf message agency.quota.v1.GetQuotaStateRequest
 */
export interface GetQuotaStateRequest {
    /**
     * tenant is the tenant identifier.
     *
     * @generated from protobuf field: string tenant = 1
     */
    tenant: string;
    /**
     * workspace is the workspace identifier.
     *
     * @generated from protobuf field: string workspace = 2
     */
    workspace: string;
}
/**
 * GetQuotaStateResponse returns current quota state.
 *
 * @generated from protobuf message agency.quota.v1.GetQuotaStateResponse
 */
export interface GetQuotaStateResponse {
    /**
     * state is the current quota state.
     *
     * @generated from protobuf field: agency.quota.v1.QuotaState state = 1
     */
    state?: QuotaState;
}
/**
 * QuotaEnforcementPolicy defines how quota is enforced.
 *
 * @generated from protobuf enum agency.quota.v1.QuotaEnforcementPolicy
 */
export enum QuotaEnforcementPolicy {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: QUOTA_ENFORCEMENT_POLICY_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * SOFT is eventually consistent with bounded overshoot (default).
     *
     * @generated from protobuf enum value: QUOTA_ENFORCEMENT_POLICY_QUOTA_SOFT = 1;
     */
    QUOTA_SOFT = 1,
    /**
     * HARD is synchronous with zero overshoot (requires DB).
     *
     * @generated from protobuf enum value: QUOTA_ENFORCEMENT_POLICY_QUOTA_HARD = 2;
     */
    QUOTA_HARD = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class QuotaConfig$Type extends MessageType<QuotaConfig> {
    constructor() {
        super("agency.quota.v1.QuotaConfig", [
            { no: 1, name: "policy", kind: "enum", T: () => ["agency.quota.v1.QuotaEnforcementPolicy", QuotaEnforcementPolicy, "QUOTA_ENFORCEMENT_POLICY_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 8, name: "tier_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "64", pattern: "^([a-z0-9][a-z0-9_-]*[a-z0-9])?$" } } } },
            { no: 2, name: "token_limit", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { lte: "9223372036854775807", gte: "0" } } } },
            { no: 3, name: "refill_rate", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { lte: "1000000000", gte: "0" } } } },
            { no: 4, name: "max_burst", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { lte: "9223372036854775807", gte: "0" } } } },
            { no: 5, name: "params", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "50", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "4096" } } } } } },
            { no: 6, name: "ingress_rps_limit", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 100000, gte: 1 } } } },
            { no: 7, name: "ingress_burst", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 10000, gte: 1 } } } }
        ]);
    }
    create(value?: PartialMessage<QuotaConfig>): QuotaConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.policy = 0;
        message.tierId = "";
        message.tokenLimit = 0n;
        message.refillRate = 0n;
        message.maxBurst = 0n;
        message.params = {};
        message.ingressRpsLimit = 0;
        message.ingressBurst = 0;
        if (value !== undefined)
            reflectionMergePartial<QuotaConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: QuotaConfig): QuotaConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.quota.v1.QuotaEnforcementPolicy policy */ 1:
                    message.policy = reader.int32();
                    break;
                case /* string tier_id */ 8:
                    message.tierId = reader.string();
                    break;
                case /* int64 token_limit */ 2:
                    message.tokenLimit = reader.int64().toBigInt();
                    break;
                case /* int64 refill_rate */ 3:
                    message.refillRate = reader.int64().toBigInt();
                    break;
                case /* int64 max_burst */ 4:
                    message.maxBurst = reader.int64().toBigInt();
                    break;
                case /* map<string, string> params */ 5:
                    this.binaryReadMap5(message.params, reader, options);
                    break;
                case /* int32 ingress_rps_limit */ 6:
                    message.ingressRpsLimit = reader.int32();
                    break;
                case /* int32 ingress_burst */ 7:
                    message.ingressBurst = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap5(map: QuotaConfig["params"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof QuotaConfig["params"] | undefined, val: QuotaConfig["params"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.quota.v1.QuotaConfig.params");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: QuotaConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.quota.v1.QuotaEnforcementPolicy policy = 1; */
        if (message.policy !== 0)
            writer.tag(1, WireType.Varint).int32(message.policy);
        /* int64 token_limit = 2; */
        if (message.tokenLimit !== 0n)
            writer.tag(2, WireType.Varint).int64(message.tokenLimit);
        /* int64 refill_rate = 3; */
        if (message.refillRate !== 0n)
            writer.tag(3, WireType.Varint).int64(message.refillRate);
        /* int64 max_burst = 4; */
        if (message.maxBurst !== 0n)
            writer.tag(4, WireType.Varint).int64(message.maxBurst);
        /* map<string, string> params = 5; */
        for (let k of globalThis.Object.keys(message.params))
            writer.tag(5, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.params[k]).join();
        /* int32 ingress_rps_limit = 6; */
        if (message.ingressRpsLimit !== 0)
            writer.tag(6, WireType.Varint).int32(message.ingressRpsLimit);
        /* int32 ingress_burst = 7; */
        if (message.ingressBurst !== 0)
            writer.tag(7, WireType.Varint).int32(message.ingressBurst);
        /* string tier_id = 8; */
        if (message.tierId !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.tierId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.quota.v1.QuotaConfig
 */
export const QuotaConfig = new QuotaConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CheckRequest$Type extends MessageType<CheckRequest> {
    constructor() {
        super("agency.quota.v1.CheckRequest", [
            { no: 1, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 2, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 3, name: "estimated_cost", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { lte: "1000000", gte: "0" } } } },
            { no: 4, name: "request_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 5, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } }
        ]);
    }
    create(value?: PartialMessage<CheckRequest>): CheckRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tenant = "";
        message.workspace = "";
        message.estimatedCost = 0n;
        message.requestId = "";
        message.sessionId = "";
        if (value !== undefined)
            reflectionMergePartial<CheckRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CheckRequest): CheckRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tenant */ 1:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 2:
                    message.workspace = reader.string();
                    break;
                case /* int64 estimated_cost */ 3:
                    message.estimatedCost = reader.int64().toBigInt();
                    break;
                case /* string request_id */ 4:
                    message.requestId = reader.string();
                    break;
                case /* string session_id */ 5:
                    message.sessionId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CheckRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tenant = 1; */
        if (message.tenant !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 2; */
        if (message.workspace !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.workspace);
        /* int64 estimated_cost = 3; */
        if (message.estimatedCost !== 0n)
            writer.tag(3, WireType.Varint).int64(message.estimatedCost);
        /* string request_id = 4; */
        if (message.requestId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.requestId);
        /* string session_id = 5; */
        if (message.sessionId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.sessionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.quota.v1.CheckRequest
 */
export const CheckRequest = new CheckRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CheckResponse$Type extends MessageType<CheckResponse> {
    constructor() {
        super("agency.quota.v1.CheckResponse", [
            { no: 1, name: "permitted", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "remaining", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "policy_applied", kind: "enum", T: () => ["agency.quota.v1.QuotaEnforcementPolicy", QuotaEnforcementPolicy, "QUOTA_ENFORCEMENT_POLICY_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 4, name: "checked_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 5, name: "denial_reason", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "1024" } } } },
            { no: 6, name: "retry_after_seconds", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { gte: "0" } } } }
        ]);
    }
    create(value?: PartialMessage<CheckResponse>): CheckResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.permitted = false;
        message.remaining = 0n;
        message.policyApplied = 0;
        message.denialReason = "";
        message.retryAfterSeconds = 0n;
        if (value !== undefined)
            reflectionMergePartial<CheckResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CheckResponse): CheckResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool permitted */ 1:
                    message.permitted = reader.bool();
                    break;
                case /* int64 remaining */ 2:
                    message.remaining = reader.int64().toBigInt();
                    break;
                case /* agency.quota.v1.QuotaEnforcementPolicy policy_applied */ 3:
                    message.policyApplied = reader.int32();
                    break;
                case /* google.protobuf.Timestamp checked_at */ 4:
                    message.checkedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.checkedAt);
                    break;
                case /* string denial_reason */ 5:
                    message.denialReason = reader.string();
                    break;
                case /* int64 retry_after_seconds */ 6:
                    message.retryAfterSeconds = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CheckResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool permitted = 1; */
        if (message.permitted !== false)
            writer.tag(1, WireType.Varint).bool(message.permitted);
        /* int64 remaining = 2; */
        if (message.remaining !== 0n)
            writer.tag(2, WireType.Varint).int64(message.remaining);
        /* agency.quota.v1.QuotaEnforcementPolicy policy_applied = 3; */
        if (message.policyApplied !== 0)
            writer.tag(3, WireType.Varint).int32(message.policyApplied);
        /* google.protobuf.Timestamp checked_at = 4; */
        if (message.checkedAt)
            Timestamp.internalBinaryWrite(message.checkedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string denial_reason = 5; */
        if (message.denialReason !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.denialReason);
        /* int64 retry_after_seconds = 6; */
        if (message.retryAfterSeconds !== 0n)
            writer.tag(6, WireType.Varint).int64(message.retryAfterSeconds);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.quota.v1.CheckResponse
 */
export const CheckResponse = new CheckResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SpendDelta$Type extends MessageType<SpendDelta> {
    constructor() {
        super("agency.quota.v1.SpendDelta", [
            { no: 1, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 2, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 3, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 4, name: "actual_cost", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { lte: "10000000", gte: "0" } } } },
            { no: 5, name: "timestamp", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 6, name: "operation_type", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9_-]*[a-z0-9]$" } } } },
            { no: 7, name: "request_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128" } } } },
            { no: 8, name: "estimated_cost", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { gte: "0" } } } }
        ]);
    }
    create(value?: PartialMessage<SpendDelta>): SpendDelta {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tenant = "";
        message.workspace = "";
        message.sessionId = "";
        message.actualCost = 0n;
        message.operationType = "";
        message.requestId = "";
        message.estimatedCost = 0n;
        if (value !== undefined)
            reflectionMergePartial<SpendDelta>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SpendDelta): SpendDelta {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tenant */ 1:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 2:
                    message.workspace = reader.string();
                    break;
                case /* string session_id */ 3:
                    message.sessionId = reader.string();
                    break;
                case /* int64 actual_cost */ 4:
                    message.actualCost = reader.int64().toBigInt();
                    break;
                case /* google.protobuf.Timestamp timestamp */ 5:
                    message.timestamp = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.timestamp);
                    break;
                case /* string operation_type */ 6:
                    message.operationType = reader.string();
                    break;
                case /* string request_id */ 7:
                    message.requestId = reader.string();
                    break;
                case /* int64 estimated_cost */ 8:
                    message.estimatedCost = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SpendDelta, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tenant = 1; */
        if (message.tenant !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 2; */
        if (message.workspace !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.workspace);
        /* string session_id = 3; */
        if (message.sessionId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.sessionId);
        /* int64 actual_cost = 4; */
        if (message.actualCost !== 0n)
            writer.tag(4, WireType.Varint).int64(message.actualCost);
        /* google.protobuf.Timestamp timestamp = 5; */
        if (message.timestamp)
            Timestamp.internalBinaryWrite(message.timestamp, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string operation_type = 6; */
        if (message.operationType !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.operationType);
        /* string request_id = 7; */
        if (message.requestId !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.requestId);
        /* int64 estimated_cost = 8; */
        if (message.estimatedCost !== 0n)
            writer.tag(8, WireType.Varint).int64(message.estimatedCost);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.quota.v1.SpendDelta
 */
export const SpendDelta = new SpendDelta$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ToolCallFrequencyCheckRequest$Type extends MessageType<ToolCallFrequencyCheckRequest> {
    constructor() {
        super("agency.quota.v1.ToolCallFrequencyCheckRequest", [
            { no: 1, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 2, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 3, name: "tool_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9_]*[a-z0-9]$" } } } },
            { no: 4, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } }
        ]);
    }
    create(value?: PartialMessage<ToolCallFrequencyCheckRequest>): ToolCallFrequencyCheckRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tenant = "";
        message.workspace = "";
        message.toolName = "";
        message.sessionId = "";
        if (value !== undefined)
            reflectionMergePartial<ToolCallFrequencyCheckRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ToolCallFrequencyCheckRequest): ToolCallFrequencyCheckRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tenant */ 1:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 2:
                    message.workspace = reader.string();
                    break;
                case /* string tool_name */ 3:
                    message.toolName = reader.string();
                    break;
                case /* string session_id */ 4:
                    message.sessionId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ToolCallFrequencyCheckRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tenant = 1; */
        if (message.tenant !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 2; */
        if (message.workspace !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.workspace);
        /* string tool_name = 3; */
        if (message.toolName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.toolName);
        /* string session_id = 4; */
        if (message.sessionId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.sessionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.quota.v1.ToolCallFrequencyCheckRequest
 */
export const ToolCallFrequencyCheckRequest = new ToolCallFrequencyCheckRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ToolCallFrequencyCheckResult$Type extends MessageType<ToolCallFrequencyCheckResult> {
    constructor() {
        super("agency.quota.v1.ToolCallFrequencyCheckResult", [
            { no: 1, name: "permitted", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "current_frequency", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } },
            { no: 3, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } },
            { no: 4, name: "retry_after_seconds", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { gte: "0" } } } },
            { no: 5, name: "checked_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<ToolCallFrequencyCheckResult>): ToolCallFrequencyCheckResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.permitted = false;
        message.currentFrequency = 0;
        message.limit = 0;
        message.retryAfterSeconds = 0n;
        if (value !== undefined)
            reflectionMergePartial<ToolCallFrequencyCheckResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ToolCallFrequencyCheckResult): ToolCallFrequencyCheckResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool permitted */ 1:
                    message.permitted = reader.bool();
                    break;
                case /* int32 current_frequency */ 2:
                    message.currentFrequency = reader.int32();
                    break;
                case /* int32 limit */ 3:
                    message.limit = reader.int32();
                    break;
                case /* int64 retry_after_seconds */ 4:
                    message.retryAfterSeconds = reader.int64().toBigInt();
                    break;
                case /* google.protobuf.Timestamp checked_at */ 5:
                    message.checkedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.checkedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ToolCallFrequencyCheckResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool permitted = 1; */
        if (message.permitted !== false)
            writer.tag(1, WireType.Varint).bool(message.permitted);
        /* int32 current_frequency = 2; */
        if (message.currentFrequency !== 0)
            writer.tag(2, WireType.Varint).int32(message.currentFrequency);
        /* int32 limit = 3; */
        if (message.limit !== 0)
            writer.tag(3, WireType.Varint).int32(message.limit);
        /* int64 retry_after_seconds = 4; */
        if (message.retryAfterSeconds !== 0n)
            writer.tag(4, WireType.Varint).int64(message.retryAfterSeconds);
        /* google.protobuf.Timestamp checked_at = 5; */
        if (message.checkedAt)
            Timestamp.internalBinaryWrite(message.checkedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.quota.v1.ToolCallFrequencyCheckResult
 */
export const ToolCallFrequencyCheckResult = new ToolCallFrequencyCheckResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QuotaState$Type extends MessageType<QuotaState> {
    constructor() {
        super("agency.quota.v1.QuotaState", [
            { no: 1, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 2, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 3, name: "remaining_tokens", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { gte: "0" } } } },
            { no: 4, name: "last_refill_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 5, name: "updated_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 6, name: "revision", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value?: PartialMessage<QuotaState>): QuotaState {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tenant = "";
        message.workspace = "";
        message.remainingTokens = 0n;
        message.revision = 0n;
        if (value !== undefined)
            reflectionMergePartial<QuotaState>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: QuotaState): QuotaState {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tenant */ 1:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 2:
                    message.workspace = reader.string();
                    break;
                case /* int64 remaining_tokens */ 3:
                    message.remainingTokens = reader.int64().toBigInt();
                    break;
                case /* google.protobuf.Timestamp last_refill_at */ 4:
                    message.lastRefillAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.lastRefillAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 5:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* uint64 revision */ 6:
                    message.revision = reader.uint64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: QuotaState, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tenant = 1; */
        if (message.tenant !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 2; */
        if (message.workspace !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.workspace);
        /* int64 remaining_tokens = 3; */
        if (message.remainingTokens !== 0n)
            writer.tag(3, WireType.Varint).int64(message.remainingTokens);
        /* google.protobuf.Timestamp last_refill_at = 4; */
        if (message.lastRefillAt)
            Timestamp.internalBinaryWrite(message.lastRefillAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 5; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* uint64 revision = 6; */
        if (message.revision !== 0n)
            writer.tag(6, WireType.Varint).uint64(message.revision);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.quota.v1.QuotaState
 */
export const QuotaState = new QuotaState$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QuotaExhaustedEvent$Type extends MessageType<QuotaExhaustedEvent> {
    constructor() {
        super("agency.quota.v1.QuotaExhaustedEvent", [
            { no: 1, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 2, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 3, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128" } } } },
            { no: 4, name: "requested_cost", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { gte: "0" } } } },
            { no: 5, name: "remaining_tokens", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { gte: "0" } } } },
            { no: 6, name: "occurred_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 7, name: "policy_applied", kind: "enum", T: () => ["agency.quota.v1.QuotaEnforcementPolicy", QuotaEnforcementPolicy, "QUOTA_ENFORCEMENT_POLICY_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } }
        ]);
    }
    create(value?: PartialMessage<QuotaExhaustedEvent>): QuotaExhaustedEvent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tenant = "";
        message.workspace = "";
        message.sessionId = "";
        message.requestedCost = 0n;
        message.remainingTokens = 0n;
        message.policyApplied = 0;
        if (value !== undefined)
            reflectionMergePartial<QuotaExhaustedEvent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: QuotaExhaustedEvent): QuotaExhaustedEvent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tenant */ 1:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 2:
                    message.workspace = reader.string();
                    break;
                case /* string session_id */ 3:
                    message.sessionId = reader.string();
                    break;
                case /* int64 requested_cost */ 4:
                    message.requestedCost = reader.int64().toBigInt();
                    break;
                case /* int64 remaining_tokens */ 5:
                    message.remainingTokens = reader.int64().toBigInt();
                    break;
                case /* google.protobuf.Timestamp occurred_at */ 6:
                    message.occurredAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.occurredAt);
                    break;
                case /* agency.quota.v1.QuotaEnforcementPolicy policy_applied */ 7:
                    message.policyApplied = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: QuotaExhaustedEvent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tenant = 1; */
        if (message.tenant !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 2; */
        if (message.workspace !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.workspace);
        /* string session_id = 3; */
        if (message.sessionId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.sessionId);
        /* int64 requested_cost = 4; */
        if (message.requestedCost !== 0n)
            writer.tag(4, WireType.Varint).int64(message.requestedCost);
        /* int64 remaining_tokens = 5; */
        if (message.remainingTokens !== 0n)
            writer.tag(5, WireType.Varint).int64(message.remainingTokens);
        /* google.protobuf.Timestamp occurred_at = 6; */
        if (message.occurredAt)
            Timestamp.internalBinaryWrite(message.occurredAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* agency.quota.v1.QuotaEnforcementPolicy policy_applied = 7; */
        if (message.policyApplied !== 0)
            writer.tag(7, WireType.Varint).int32(message.policyApplied);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.quota.v1.QuotaExhaustedEvent
 */
export const QuotaExhaustedEvent = new QuotaExhaustedEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RateLimitExceededEvent$Type extends MessageType<RateLimitExceededEvent> {
    constructor() {
        super("agency.quota.v1.RateLimitExceededEvent", [
            { no: 1, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 2, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 3, name: "user_sub", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "256" } } } },
            { no: 4, name: "current_rate", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } },
            { no: 5, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } },
            { no: 6, name: "occurred_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 7, name: "layer", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64" } } } }
        ]);
    }
    create(value?: PartialMessage<RateLimitExceededEvent>): RateLimitExceededEvent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tenant = "";
        message.workspace = "";
        message.userSub = "";
        message.currentRate = 0;
        message.limit = 0;
        message.layer = "";
        if (value !== undefined)
            reflectionMergePartial<RateLimitExceededEvent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RateLimitExceededEvent): RateLimitExceededEvent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tenant */ 1:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 2:
                    message.workspace = reader.string();
                    break;
                case /* string user_sub */ 3:
                    message.userSub = reader.string();
                    break;
                case /* int32 current_rate */ 4:
                    message.currentRate = reader.int32();
                    break;
                case /* int32 limit */ 5:
                    message.limit = reader.int32();
                    break;
                case /* google.protobuf.Timestamp occurred_at */ 6:
                    message.occurredAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.occurredAt);
                    break;
                case /* string layer */ 7:
                    message.layer = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RateLimitExceededEvent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tenant = 1; */
        if (message.tenant !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 2; */
        if (message.workspace !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.workspace);
        /* string user_sub = 3; */
        if (message.userSub !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.userSub);
        /* int32 current_rate = 4; */
        if (message.currentRate !== 0)
            writer.tag(4, WireType.Varint).int32(message.currentRate);
        /* int32 limit = 5; */
        if (message.limit !== 0)
            writer.tag(5, WireType.Varint).int32(message.limit);
        /* google.protobuf.Timestamp occurred_at = 6; */
        if (message.occurredAt)
            Timestamp.internalBinaryWrite(message.occurredAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* string layer = 7; */
        if (message.layer !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.layer);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.quota.v1.RateLimitExceededEvent
 */
export const RateLimitExceededEvent = new RateLimitExceededEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RecordRequest$Type extends MessageType<RecordRequest> {
    constructor() {
        super("agency.quota.v1.RecordRequest", [
            { no: 1, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 2, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 3, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 4, name: "tokens_consumed", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { lte: "10000000", gte: "0" } } } },
            { no: 5, name: "operation_type", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9_-]*[a-z0-9]$" } } } },
            { no: 6, name: "timestamp", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<RecordRequest>): RecordRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tenant = "";
        message.workspace = "";
        message.sessionId = "";
        message.tokensConsumed = 0n;
        message.operationType = "";
        if (value !== undefined)
            reflectionMergePartial<RecordRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RecordRequest): RecordRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tenant */ 1:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 2:
                    message.workspace = reader.string();
                    break;
                case /* string session_id */ 3:
                    message.sessionId = reader.string();
                    break;
                case /* int64 tokens_consumed */ 4:
                    message.tokensConsumed = reader.int64().toBigInt();
                    break;
                case /* string operation_type */ 5:
                    message.operationType = reader.string();
                    break;
                case /* google.protobuf.Timestamp timestamp */ 6:
                    message.timestamp = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.timestamp);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RecordRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tenant = 1; */
        if (message.tenant !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 2; */
        if (message.workspace !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.workspace);
        /* string session_id = 3; */
        if (message.sessionId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.sessionId);
        /* int64 tokens_consumed = 4; */
        if (message.tokensConsumed !== 0n)
            writer.tag(4, WireType.Varint).int64(message.tokensConsumed);
        /* string operation_type = 5; */
        if (message.operationType !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.operationType);
        /* google.protobuf.Timestamp timestamp = 6; */
        if (message.timestamp)
            Timestamp.internalBinaryWrite(message.timestamp, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.quota.v1.RecordRequest
 */
export const RecordRequest = new RecordRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RecordResponse$Type extends MessageType<RecordResponse> {
    constructor() {
        super("agency.quota.v1.RecordResponse", [
            { no: 1, name: "recorded", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "recorded_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<RecordResponse>): RecordResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.recorded = false;
        if (value !== undefined)
            reflectionMergePartial<RecordResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RecordResponse): RecordResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool recorded */ 1:
                    message.recorded = reader.bool();
                    break;
                case /* google.protobuf.Timestamp recorded_at */ 2:
                    message.recordedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.recordedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RecordResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool recorded = 1; */
        if (message.recorded !== false)
            writer.tag(1, WireType.Varint).bool(message.recorded);
        /* google.protobuf.Timestamp recorded_at = 2; */
        if (message.recordedAt)
            Timestamp.internalBinaryWrite(message.recordedAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.quota.v1.RecordResponse
 */
export const RecordResponse = new RecordResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReconcileRequest$Type extends MessageType<ReconcileRequest> {
    constructor() {
        super("agency.quota.v1.ReconcileRequest", [
            { no: 1, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 2, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 3, name: "deltas", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SpendDelta, options: { "buf.validate.field": { repeated: { minItems: "1", maxItems: "1000" } } } }
        ]);
    }
    create(value?: PartialMessage<ReconcileRequest>): ReconcileRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tenant = "";
        message.workspace = "";
        message.deltas = [];
        if (value !== undefined)
            reflectionMergePartial<ReconcileRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ReconcileRequest): ReconcileRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tenant */ 1:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 2:
                    message.workspace = reader.string();
                    break;
                case /* repeated agency.quota.v1.SpendDelta deltas */ 3:
                    message.deltas.push(SpendDelta.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ReconcileRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tenant = 1; */
        if (message.tenant !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 2; */
        if (message.workspace !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.workspace);
        /* repeated agency.quota.v1.SpendDelta deltas = 3; */
        for (let i = 0; i < message.deltas.length; i++)
            SpendDelta.internalBinaryWrite(message.deltas[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.quota.v1.ReconcileRequest
 */
export const ReconcileRequest = new ReconcileRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReconcileResponse$Type extends MessageType<ReconcileResponse> {
    constructor() {
        super("agency.quota.v1.ReconcileResponse", [
            { no: 1, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 2, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 3, name: "deltas_processed", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } },
            { no: 4, name: "remaining_tokens", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { gte: "0" } } } },
            { no: 5, name: "reconciled_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<ReconcileResponse>): ReconcileResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tenant = "";
        message.workspace = "";
        message.deltasProcessed = 0;
        message.remainingTokens = 0n;
        if (value !== undefined)
            reflectionMergePartial<ReconcileResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ReconcileResponse): ReconcileResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tenant */ 1:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 2:
                    message.workspace = reader.string();
                    break;
                case /* int32 deltas_processed */ 3:
                    message.deltasProcessed = reader.int32();
                    break;
                case /* int64 remaining_tokens */ 4:
                    message.remainingTokens = reader.int64().toBigInt();
                    break;
                case /* google.protobuf.Timestamp reconciled_at */ 5:
                    message.reconciledAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.reconciledAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ReconcileResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tenant = 1; */
        if (message.tenant !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 2; */
        if (message.workspace !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.workspace);
        /* int32 deltas_processed = 3; */
        if (message.deltasProcessed !== 0)
            writer.tag(3, WireType.Varint).int32(message.deltasProcessed);
        /* int64 remaining_tokens = 4; */
        if (message.remainingTokens !== 0n)
            writer.tag(4, WireType.Varint).int64(message.remainingTokens);
        /* google.protobuf.Timestamp reconciled_at = 5; */
        if (message.reconciledAt)
            Timestamp.internalBinaryWrite(message.reconciledAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.quota.v1.ReconcileResponse
 */
export const ReconcileResponse = new ReconcileResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetQuotaStateRequest$Type extends MessageType<GetQuotaStateRequest> {
    constructor() {
        super("agency.quota.v1.GetQuotaStateRequest", [
            { no: 1, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 2, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } }
        ]);
    }
    create(value?: PartialMessage<GetQuotaStateRequest>): GetQuotaStateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tenant = "";
        message.workspace = "";
        if (value !== undefined)
            reflectionMergePartial<GetQuotaStateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetQuotaStateRequest): GetQuotaStateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tenant */ 1:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 2:
                    message.workspace = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetQuotaStateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tenant = 1; */
        if (message.tenant !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 2; */
        if (message.workspace !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.workspace);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.quota.v1.GetQuotaStateRequest
 */
export const GetQuotaStateRequest = new GetQuotaStateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetQuotaStateResponse$Type extends MessageType<GetQuotaStateResponse> {
    constructor() {
        super("agency.quota.v1.GetQuotaStateResponse", [
            { no: 1, name: "state", kind: "message", T: () => QuotaState, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<GetQuotaStateResponse>): GetQuotaStateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetQuotaStateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetQuotaStateResponse): GetQuotaStateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.quota.v1.QuotaState state */ 1:
                    message.state = QuotaState.internalBinaryRead(reader, reader.uint32(), options, message.state);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetQuotaStateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.quota.v1.QuotaState state = 1; */
        if (message.state)
            QuotaState.internalBinaryWrite(message.state, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.quota.v1.GetQuotaStateResponse
 */
export const GetQuotaStateResponse = new GetQuotaStateResponse$Type();
/**
 * @generated ServiceType for protobuf service agency.quota.v1.QuotaEnforcerService
 */
export const QuotaEnforcerService = new ServiceType("agency.quota.v1.QuotaEnforcerService", [
    { name: "Check", options: {}, I: CheckRequest, O: CheckResponse },
    { name: "Record", options: {}, I: RecordRequest, O: RecordResponse },
    { name: "Reconcile", options: {}, I: ReconcileRequest, O: ReconcileResponse },
    { name: "GetQuotaState", options: {}, I: GetQuotaStateRequest, O: GetQuotaStateResponse }
]);
